import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
// import { firestore } from 'firebase';
import * as firebase from 'firebase/app';
// import 'firebase/firestore';
import { SessionItemInfo, ShareableItem, BriefInfo, BriefType, BriefShareStatus, ItemStatus, ShareableItemType, ShareableItemTypes, SessionItemType } from 'globals/store/share.data';
import { LogService } from './log.service';
import { ShareService } from './share.service';
import { doc, Firestore, serverTimestamp, setDoc, updateDoc } from '@angular/fire/firestore';
import { jsonCopyObject } from 'globals/helpers/helpers';
import { getOneStorePromise } from '../store/ui.era';
import { shareFeature } from '../store/share.era';
import { lastValueFrom, take } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ShareBriefsService {
  readonly _file = 'share.briefs.service.ts'

  constructor(
    private db: Firestore,
    private log: LogService,
    public store: Store,
    private shareService: ShareService,
  ) { }


  async addNewShareSessionItemView(sessionId: string, programId:string, performerId: string, performerName: string, type: SessionItemType) {
    if (!ShareableItemTypes[type]) return console.log("ADDING AN INVALID TYPE: " + type, { ShareableItemTypes: ShareableItemTypes })
    const id = await this.shareService.createSlugCode()
    const shareSessionTypeInfo: SessionItemInfo = {
      id,
      key:sessionId + "_" + (performerId ? performerId : ''),
      sessionId,
      programId,
      performerId,
      performerName,
      status: 'Active',
    }
    try {
      const insertObject:ShareableItem = {
        type,
        code: id,
        info: shareSessionTypeInfo,
        eventId: this.shareService.eventId,
        accountId: this.shareService.accountId,
        timestamp: serverTimestamp()
      }
      await setDoc(doc(this.db, '/shareables/' + id), insertObject)
    } catch (error) {
      this.log.error({
        file:this._file,
        data:{sessionId, programId, performerId, type},
        function:'addNewShareSessionItemView -> upsertPublishInfo',
        message:'There was an error updating the event',
        error
      })
    }
  }

  async addNewBrief(type: BriefType, id: string,) {
    console.log("Adding new brief? ...", { type, id })
    try {
      const shareBrief: BriefInfo = {
        id: await this.shareService.createSlugCode(),
        status: 'On',
      }
      if (type === 'performer') shareBrief.performerId = id
      if (type === 'exhibitor') shareBrief.exhibitorId = id
      if (type === 'resource') shareBrief.resourceId = id
      if (type === 'attendee') shareBrief.attendeeId = id
      
      const insertObject: ShareableItem = {
        type: type === 'performer' ? 'performer' : type === 'exhibitor' ? 'exhibitorBrief' : type === 'attendee'? 'attendeeBrief' : 'resourceBrief',
        code:shareBrief.id,
        info:shareBrief,
        eventId: this.shareService.eventId,
        accountId: this.shareService.accountId,
        timestamp: serverTimestamp()
      }
      console.log({ insertObject })
      await setDoc(doc(this.db, '/shareables/' + shareBrief.id), insertObject)
    } catch (error) {
      this.log.error({
        file:this._file,
        function:'addNewBrief -> insertBrief',
        message:'There was an error updating the sharable',
        error
      })
    }

  }

  async changeBriefShareStatus(briefInfo: BriefInfo, status: BriefShareStatus) {
    try {
      briefInfo = jsonCopyObject(briefInfo)
      briefInfo.status = status
      await updateDoc(doc(this.db, '/shareables/' + briefInfo.id), { info: briefInfo }).catch(response=>{
        this.log.error({ file:this._file, function:'updateBriefShareStatus', message:'There was an error updating the status', data:{ info: briefInfo }, error: new Error(), response} )
      })
    } catch (error) {
      this.log.error({
        file:this._file,
        function:'changeBriefStatus',
        message:'There was an error updating the brief share status',
        error
      })
    }
  }

  async removePerformerFromSomeSessionShareables(performerId: string, sessionId: string) { // only shareables that matter - for example, synopsis, which should not be set to the performer if they are not there.  Shareables applicable only to the performer shouldn't matter (until Tony notices I guess) - for example removing and then adding back a performer still keeps their other shareables active
    const oldInfos: {[code: string]: SessionItemInfo} = await lastValueFrom(this.store.select(shareFeature.selectSynopsis).pipe(take(1))  )
    const oldInfo = oldInfos[sessionId];
    // [ ] check if this works
    if (!oldInfo|| oldInfo.performerId !== performerId) return

    const info: SessionItemInfo = { id: oldInfo.id, key: oldInfo.key, sessionId, programId: oldInfo.programId, performerId: null, performerName: "", status: oldInfo.status }
    this.shareService.upsertShareInfo({ info }, info.id)
  }

}